import FilePondPluginFileEncode from "filepond-plugin-file-encode";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "filepond/dist/filepond.min.css";
import React, { Component } from "react";
import { FilePond, registerPlugin } from "react-filepond";
import { connect } from "react-redux";
import Select from "react-select";
import { userActions } from "../../_actions";
import { BtnRound } from "../../_components/BtnRound";
import { CardRotate } from "../../_components/CardRotate";
import { userConstants } from "../../_constants";
import { formatDate } from "../../_helpers/formatDate";
import "../../assets/css/addNews.css";

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileEncode
);

class AddNews_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      type: "",
      type_object: {},
      description: "",
      subtitle: "",
      author: "",
      files: [],
      newFiles: [],
      status: "",
      firstTime: props.data.title === undefined,
      type_options: [
        { id: 1, name: "داخلی" },
        { id: 2, name: "عمومی" },
        { id: 3, name: "روابط عمومی" },
        { id: 4, name: "اخبار بیمارستان" },
        { id: 5, name: "مقاله پزشکی" },
        { id: 6, name: "آموزش پزشکی" },
      ],
      all_types_options: [
        { id: 1, name: "اخبار" },
        { id: 2, name: "تبریک" },
        { id: 3, name: "نسلیت" },
        { id: 4, name: "رویداد های ویژه" },
        { id: 5, name: "ایام تقویمی" },
        { id: 6, name: "شهادت" },
        { id: 7, name: "ولادت" },
      ],
      newsPosted: false,
      postedNewsID: null,
      postedNewsDate: null,
      postedImageDate: null,
      images: [],
      weHaveImgMain: false,
    };
    this.globalStorage = this.props.globalStorage;
  }

  componentDidMount = () => {
    document.querySelector(".logout-btn").classList.add("hidden");
    document.querySelector(".logout-btn-bg").classList.add("hidden");
    const { title, subtitle, category, body, author, status } = this.props.data;
    this.setState({
      title: title || "",
      subtitle: subtitle || "",
      type: Number(category) || "",
      type_object:
        this.state.type_options.find((type) => type.id === Number(category)) ||
        "",
      description: body || "",
      author: author || "",
      status: status,
    });
  };

  componentWillUnmount = () => {
    this.reset();
    document.querySelector(".logout-btn").classList.remove("hidden");
    document.querySelector(".logout-btn-bg").classList.remove("hidden");
  };

  goBack = () => {
    this.props.history.goBack();
  };

  reset = () => {
    this.setState({
      title: "",
      type: "",
      type_object: {},
      description: "",
      subtitle: "",
      author: "",
      files: [],
      newFiles: [],
      status: "",
      firstTime: false,
      newsPosted: false,
      postedNewsID: null,
      postedNewsDate: null,
      postedImageDate: null,
      images: [],
      weHaveImgMain: false,
    });
  };

  onBack = () => {
    this.props
      .dispatch(userActions.question("هشدار", "آیا از ثبت نشدن اطمینان دارید؟"))
      .then((r) => {
        if (r.value) {
          this.props.handleModal();
        }
      });
  };

  onPost = () => {
    const {
      title,
      description,
      subtitle,
      author,
      files,
      firstTime,
      type_object,
      status,
      all_types_options,
    } = this.state;
    const { currentEvent } = this.props;

    if (firstTime) {
      const data = {
        title,
        category: type_object.id,
        body: description,
        subtitle,
        author,
        status: "active",
        type:
          currentEvent !== undefined
            ? all_types_options[currentEvent + 1].id
            : all_types_options[0].id,
      };

      this.props
        .dispatch(
          userActions.API(
            "post",
            `v1/sub_admin/hospital/announcements`,
            data,
            true,
            false,
            JSON.parse(localStorage.getItem("tokenAdmin"))
          )
        )
        .then((res) => {
          this.setState({
            newsPosted: true,
            postedNewsID: res.data.id,
            postedNewsDate: res.data.updated_at,
          });

          if (files.length !== 0) {
            files.forEach((file, i) => {
              file.file &&
                this.props
                  .dispatch(
                    userActions.API(
                      "post",
                      `v1/sub_admin/hospital/announcements/${res.data.id}/image`,
                      file,
                      true,
                      false,
                      JSON.parse(localStorage.getItem("tokenAdmin"))
                    )
                  )
                  .then((res) => {
                    if (i === files.length - 1) {
                      this.setState({
                        files: [],
                      });
                      this.getImages(res.data.id);
                    }
                  })
                  .catch(() =>
                    userActions.failure(userConstants.ERRORS["serverError"])
                  );
            });
          } else {
            this.getImages(res.data.id);
          }
        })
        .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
    } else {
      const data = {
        id: this.props.data ? this.props.data.id : undefined,
        title,
        category: type_object.id,
        body: description,
        subtitle,
        author,
        status,
        type:
          currentEvent !== undefined
            ? all_types_options[currentEvent + 1].id
            : all_types_options[0].id,
      };

      this.props
        .dispatch(
          userActions.API(
            "put",
            `v1/sub_admin/hospital/announcements`,
            data,
            true,
            false,
            JSON.parse(localStorage.getItem("tokenAdmin"))
          )
        )
        .then((res) => {
          this.setState({
            newsPosted: true,
            postedNewsID: res.data.id,
            postedNewsDate: res.data.updated_at,
          });

          if (files.length !== 0) {
            files.forEach((file, i) => {
              file.file &&
                this.props
                  .dispatch(
                    userActions.API(
                      "post",
                      `v1/sub_admin/hospital/announcements/${res.data.id}/image`,
                      file,
                      true,
                      false,
                      JSON.parse(localStorage.getItem("tokenAdmin"))
                    )
                  )
                  .then((res) => {
                    if (i === files.length - 1) {
                      this.setState({
                        files: [],
                      });
                      this.getImages(res.data.id);
                    }
                  })
                  .catch(() =>
                    userActions.failure(userConstants.ERRORS["serverError"])
                  );
            });
          } else {
            this.getImages(res.data.id);
          }
        })
        .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
    }
  };

  handleFileUpload = (fileItems, main = false) => {
    this.setState({
      files: fileItems.map((fileItem, i) => {
        return {
          file: `data:${
            fileItem.file.type
          };base64,${fileItem.getFileEncodeBase64String()}`,
          main,
        };
      }),
    });
  };

  getImages = () => {
    const { postedNewsID } = this.state;

    this.props
      .dispatch(
        userActions.API(
          "get",
          `v1/user/hospital/announcements/${postedNewsID}`,
          null,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        this.setState({
          postedImageDate: res.data.updated_at,
          images: res.data.images,
        });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  setMainImage = (newsId, id) => {
    const { getImages } = this;
    this.props
      .dispatch(
        userActions.API(
          "put",
          `v1/sub_admin/hospital/announcements/${newsId}/image/${id}/main`,
          null,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        this.setState({ weHaveImgMain: true });
        getImages();
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  deleteImage = (newsId, id) => {
    const { getImages } = this;
    this.props
      .dispatch(
        userActions.API(
          "delete",
          `v1/sub_admin/hospital/announcements/${newsId}/image/${id}`,
          null,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        getImages();
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  render() {
    const {
      description,
      title,
      type_object,
      subtitle,
      author,
      files,
      type_options,
      newsPosted,
      postedNewsDate,
      postedImageDate,
      images,
    } = this.state;
    let eventTitle = this.props.title ? this.props.title : "";
    const { onBack, onPost, deleteImage, setMainImage } = this;
    const names = ["محتوا", "عکس ها", "نمایش نهایی"];
    const dates = [postedNewsDate, postedImageDate, null];
    const labels = ["محتوا", "عکس ها", "نمایش نهایی"];

    return (
      <Container>
        {!newsPosted ? (
          <>
            <Title text={`افزودن ${eventTitle}`} />
            <div className="w-100 mb-4 d-flex flex-wrap">
              <p className="w-100 text-right px-3 font-weight-bold font-weight-bold txt_addNew">{`عنوان ${eventTitle}`}</p>
              <Input
                value={title}
                onChange={(e) => this.setState({ title: e.target.value })}
              />
            </div>

            <div className="w-100 mb-4 d-flex flex-wrap">
              <p className="w-100 text-right px-3 font-weight-bold font-weight-bold txt_addNew">
                دسته بندی
              </p>
              <div className="w-100">
                <SelectType
                  className="w-100"
                  value={type_object}
                  options={type_options}
                  placeholder="انتخاب دسته بندی"
                  onChange={(e) =>
                    this.setState({
                      type: e.name,
                      type_object: e,
                    })
                  }
                />
              </div>
            </div>

            <div className="w-100 mb-4 d-flex flex-wrap">
              <p className="w-100 text-right px-3 font-weight-bold font-weight-bold txt_addNew">
                {`مختصری از ${eventTitle}`}
              </p>
              <Input
                value={subtitle}
                onChange={(e) => this.setState({ subtitle: e.target.value })}
              />
            </div>

            <div className="w-100 mb-4 d-flex flex-wrap">
              <p className="w-100 text-right px-3 font-weight-bold font-weight-bold txt_addNew">
                {`شرح کامل ${eventTitle}`}
              </p>
              <Textarea
                value={description}
                onChange={(e) =>
                  this.setState({
                    description: e.target.value,
                  })
                }
              />
            </div>

            <div className="w-100 mb-4 d-flex flex-wrap">
              <p className="w-100 text-right px-3 font-weight-bold font-weight-bold txt_addNew">
                نویسنده
              </p>
              <Input
                value={author}
                onChange={(e) =>
                  this.setState({
                    author: e.target.value,
                  })
                }
              />
            </div>

            <div className="mb-4 d-inline-block w-100">
              <p className="w-100 text-right px-3 font-weight-bold font-weight-bold txt_addNew">
                بارگذاری فایل برای این خبر
              </p>
              <div
                className="row justify-content-center"
                style={{ width: "98%", margin: "0 auto" }}
              >
                <div
                  className="d-flex flex-column attachFile container shadow guide"
                  style={{
                    borderRadius: "20px",
                    padding: "10px 10px 0 10px",
                    color: "#104C82",
                  }}
                >
                  <p
                    style={{ margin: 0, padding: "36px", textAlign: "center" }}
                  >
                    فایـل را بکشیـد و رهـا کنیـد
                  </p>
                  <FilePond
                    files={files}
                    allowReorder={false}
                    allowMultiple={true}
                    onupdatefiles={this.handleFileUpload}
                    allowFileEncode={true}
                    labelIdle="گالری تصاویر"
                  />
                  <p
                    style={{
                      margin: 0,
                      padding: "25px 30px 30px 30px",
                      textAlign: "center",
                    }}
                  >
                    حداکثـر حجـم بارگـذاری فایـل 20MB می باشـد
                  </p>
                </div>
              </div>
            </div>
            <div className="mb-4 w-100 d-inline-block">
              <p className="w-100 text-right px-3 font-weight-bold font-weight-bold txt_addNew">
                * توجه تاریخ به صورت خودکار توسط سیستم در زمان انتشار قرار می
                گیرد.
              </p>
            </div>
            <div className="d-flex justify-content-center align-items-center addnews_container">
              <button
                className=" btn btn-primary rounded-pill iransans btn_addnew py-3 mx-2"
                onClick={() => {
                  if (title.length === 0) {
                    return userActions.failure("عنوان خبر را پر کنید");
                  } else if (type_object.name === undefined) {
                    return userActions.failure("نوع خبر را انتخاب کنید");
                  } else if (description.length === 0) {
                    return userActions.failure("شرح کامل خبر را پر کنید");
                  }
                  return onPost();
                }}
              >
                ادامه
              </button>
              <button
                onClick={onBack}
                className="btn_empty btn rounded-pill iransans py-3 mx-2 "
              >
                بازگشت
              </button>
            </div>
          </>
        ) : (
          <>
            <Title text="وضعیت خبر" />
            <Timeline dates={dates} names={names} labels={labels} />
            <div className="row">
              <div className="col-lg-12 indexSec timeline mx-auto">
                {images.length !== 0 && (
                  <div
                    className="border-0 h-100 d-flex align-items-center justify-content-center mb-3"
                    style={{ gap: "10px", flexWrap: "wrap" }}
                  >
                    {images.map((image, i) => {
                      const { file, main, announcement_id, id } = image;
                      return (
                        <CardRotate
                          active={main}
                          cancelText={"حذف"}
                          submitText={"اصلی"}
                          className={`${main ? "cover-main" : ""}`}
                          onCancel={() => {
                            this.props
                              .dispatch(
                                userActions.question(
                                  "حذف",
                                  "آیا از حذف  این عکس مطمئن هستید؟"
                                )
                              )
                              .then((r) => {
                                if (r.value) {
                                  deleteImage(announcement_id, id);
                                }
                              });
                          }}
                          onSubmit={() => {
                            this.props
                              .dispatch(
                                userActions.question(
                                  "عکس شاخص",
                                  "آیا از انتخاب این عکس به عنوان شاخص مطمئن هستید؟"
                                )
                              )
                              .then((r) => {
                                if (r.value) {
                                  setMainImage(announcement_id, id);
                                }
                              });
                          }}
                          background={`${userConstants.SERVER_URL}${file.url}`}
                        />
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
            <div className="d-flex justify-content-center align-items-center addnews_container mt-3">
              <button
                className="btn btn-primary rounded-pill iransans btn_addnew py-3 mx-2"
                onClick={() => {
                  if (this.state.weHaveImgMain === false) {
                    if (images.length !== 0) {
                      const { announcement_id, id } = images[0];
                      setMainImage(announcement_id, id);
                    }
                  }
                  this.props.handleModal();
                  this.props.afterPost();
                }}
              >
                ثبت نهایی
              </button>
              <button
                onClick={() => this.setState({ newsPosted: false })}
                className="btn_empty btn rounded-pill iransans py-3 mx-2 "
              >
                بازگشت
              </button>
            </div>
          </>
        )}
      </Container>
    );
  }
}

class Container extends Component {
  render() {
    return (
      <div className="login-admin">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 addNews">
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class Input extends Component {
  render() {
    const { value, onChange } = this.props;
    return (
      <input
        name="name"
        type="text"
        className="form-control"
        aria-label="Full Name"
        value={value}
        onChange={onChange}
      />
    );
  }
}

class SelectType extends Component {
  render() {
    const { value, onChange, options, placeholder } = this.props;
    const selectStyle = {
      container: (baseStyles) => ({
        ...baseStyles,
        height: "50px",
      }),
      control: (baseStyles) => ({
        ...baseStyles,
        background: "#e8e8e8",
        border: "none",
        padding: "6px 10px 6px 5px",
        height: "100%",
      }),
      menu: (baseStyles) => ({
        ...baseStyles,
        zIndex: "999",
        textAlign: "right",
      }),
    };

    return (
      <Select
        styles={selectStyle}
        value={value}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        getOptionLabel={(opt) => opt.name}
        getOptionValue={(opt) => opt.id}
      />
    );
  }
}

class Textarea extends Component {
  render() {
    const { value, onChange } = this.props;
    return (
      <textarea
        className="special-textarea"
        value={value}
        onChange={onChange}
      />
    );
  }
}

class Title extends Component {
  render() {
    const { text } = this.props;
    return (
      <div className="addNews__banner">
        <p>{text}</p>
      </div>
    );
  }
}

class Timeline extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.dates.filter((date) => date !== null).length - 1,
      previous: 0,
    };
  }

  render() {
    const { dates, names, labels } = this.props;
    const { value } = this.state;

    return (
      <div className="row timelineParent">
        <div className="col-xl-12 col-lg-12 col-md-11 col-sm-10 indexSec timeline mx-auto mb-3">
          <div className="border-0 h-100 ">
            <div
              className="card border-0 shadow-smm"
              style={{ borderRadius: "20px" }}
            >
              <div className="card-body" style={{ height: "270px" }}>
                <div
                  style={{
                    width: "100%",
                    height: "100px",
                    margin: "0 auto 70px auto",
                  }}
                >
                  <div className="text-center title">
                    <span>
                      نـوار اعلام وضعیت نیازسنجی هـای درخـواست شـده توسـط شمـا
                    </span>
                  </div>
                  <div className="row">
                    <div className="col-12 py-5 d-flex flex-row-reverse justify-content-center align-items-center gap-sm">
                      <div className="position-relative">
                        <BtnRound
                          className={`${
                            value >= 0 ? "bg-primary" : "bg-gray"
                          } basic-logo`}
                          style={{ borderRadius: "50%" }}
                          onClick={() => this.setState({ value: 0 })}
                        />
                        <p
                          className={`position-absolute m-0 btn-text digi-font ${
                            value >= 0 ? "text-primary" : ""
                          }`}
                        >
                          {names[0]}
                        </p>
                      </div>
                      <div
                        className={`line ${value >= 1 ? "line-active" : ""}`}
                      ></div>
                      <div className="position-relative">
                        <BtnRound
                          className={`${
                            value >= 1 ? "bg-primary" : "bg-gray"
                          } payesh-logo`}
                          style={{ borderRadius: "50%" }}
                          onClick={() => this.setState({ value: 1 })}
                        />
                        <p
                          className={`position-absolute m-0 btn-text digi-font ${
                            value >= 1 ? "text-primary" : ""
                          }`}
                        >
                          {names[1]}
                        </p>
                      </div>
                      <div
                        className={`line ${value >= 2 ? "line-active" : ""}`}
                      ></div>
                      <div className="position-relative">
                        <BtnRound
                          className={`${
                            value >= 2 ? "bg-primary" : "bg-gray"
                          } question-logo`}
                          style={{ borderRadius: "50%" }}
                          onClick={() => this.setState({ value: 2 })}
                        />
                        <p
                          className={`position-absolute m-0 btn-text digi-font ${
                            value >= 2 ? "text-primary" : ""
                          }`}
                        >
                          {names[2]}
                        </p>
                      </div>
                    </div>
                  </div>
                  {dates[value] !== null ? (
                    value === 0 ? (
                      <p className="mb-0 text-center">
                        {`${labels[value]} در تاریخ `}
                        <span className="iran-sans-imp">
                          {formatDate(dates[value])}
                        </span>
                        {`ثبت شد .`}
                      </p>
                    ) : value === 1 ? (
                      <p className="mb-0 text-center">
                        {`${labels[value]} در تاریخ `}
                        <span className="iran-sans-imp">
                          {formatDate(dates[value])}
                        </span>
                        {`ثبت شد .`}
                      </p>
                    ) : (
                      <p className="mb-0 text-center">
                        {`درخواست شما توسط ${labels[value]} در تاریخ `}
                        <span className="iran-sans-imp">
                          {formatDate(dates[value])}
                        </span>
                        {` بررسی شد.`}
                      </p>
                    )
                  ) : (
                    <p className="mb-0 text-center">
                      این مرحله هنوز تکمیل نشده است
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const AddNews = connect((state) => ({
  globalStorage: state.globalStorage,
}))(AddNews_);

export { AddNews };
